module.exports = "/templates/bds/public/images/7cbcbddddfde884c8aa69b672d24db87.png";